module.exports = __webpack_public_path__ + "static/crm-65668a104b930ef6da74c2f3f7263bf8.png";